import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const ButtonSelectorItem = ({
  type,
  itemValue,
  value,
  name,
  disabled,
  testId,
  icon,
  text,
  onChange
}) => {
  return (
    <div className="button-selector__item">
      <input
        className="button-selector__item-input"
        type={type}
        id={`${itemValue}-id`}
        name={name}
        onChange={onChange}
        value={type === 'checkbox' ? undefined : itemValue}
        checked={type === 'checkbox' ? value : undefined}
        disabled={disabled}
        data-testid={testId}
      />
      <label
        className="button-selector__item-label"
        htmlFor={`${itemValue}-id`}
        data-testid={`${itemValue}-id`}
      >
        <div className="button-selector__item-icon">
          <Icon glyph={icon} size="3.2rem" />
        </div>
        <span className="button-selector__item-text">{text}</span>
      </label>
    </div>
  );
};

ButtonSelectorItem.propTypes = {
  type: PropTypes.oneOf(['radio', 'checkbox']),
  itemValue: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  onChange: PropTypes.func
};

const ButtonSelector = ({
  className,
  type,
  onChange,
  value,
  disabled,
  children
}) => {
  const handleChange = useCallback(
    event => {
      const target = event.target;
      onChange(event, {
        value: target.value,
        name: target.name,
        checked: target.checked
      });
    },
    [onChange]
  );
  return (
    <div className={className} data-testid="button-selector">
      <div className="button-selector">
        {React.Children.map(children, (child, index) => {
          return React.cloneElement(child, {
            key: `button-selector-${index}`,
            type,
            disabled,
            value,
            onChange: handleChange
          });
        })}
      </div>
    </div>
  );
};

ButtonSelector.defaultProps = {
  type: 'radio',
  value: '',
  disabled: false
};

ButtonSelector.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['radio', 'checkbox']),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool
};

ButtonSelector.Item = ButtonSelectorItem;

export default ButtonSelector;
